import React from 'react';
import CorePage from '../../views/core/CorePage';
import UserStorageUtil from '../../util/UserStorageUtil';
import CoreAjax from '../../util/CoreAjax';
import $ from 'jquery';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import Errmsg from './Errmsg';

export default class OpenLessonView extends CorePage{
	
	constructor(props) {
		super(props);
		this.state = { "dataLoaded": false, data: {}, lessonUrl:null, iFrameHeight: '0px', AlertModalShow:false}
		this.requestParams = "";
		this.trackId = null;		
		this.trackLessonClose = this.trackLessonClose.bind(this);
		this.setContentSize = this.setContentSize.bind(this);
		this.resizeCall = this.resizeCall.bind(this);		
		this.userId = null;
		
		this.enableTimer = true;
		this.enableSessionTimer = true;
		this.previousEventObj = {};
		this.icepieTrackingTimer = false;
		this.icepieActivityTrackingTimer = true;
		this.currentDD = 0;
		this.pulseInteractivityId = null;
		this.interativeType = null;
		this.lessonViewStopped = false;

		this.hideAlertModal = this.hideAlertModal.bind(this);
		this.errorMsg={
			heading:'',
			srcval:'',
			description:''
		}
	}

	componentDidMount() {		
		this.getLessonUrl();
		
		var me =  this;
		
		var myConfObj = {
		  iframeMouseOver : false
		}
		
		$(window).on('beforeunload', function() {			
			me.trackLessonClose();
		});
		$(window).on('unload', function() {
			me.trackLessonClose();	
		});		
		
		$(window).resize(function(){
			me.setContentSize();
		});
		
		this.setContentSize();
	}	
	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.trackLessonClose);
	}
	initiateTimer(){
		var me = this;
		setInterval(() => {
				if(me.enableTimer){
	   	 		//console.log("initiateTimer ::");
	   	 		me.trackLessonClose();
	   	 	}
	   	 }, 5000);
	}
	
	setLessonNameAsTitle(lessonId){
		try{
			if(lessonId){
				var title = UserStorageUtil.getStoredSessionItem(lessonId);

				if(!title){
					title = sessionStorage.getItem(lessonId);
				}else{
					title = " " + title + " ";

					if(sessionStorage){
						if(!sessionStorage.getItem(lessonId))
							sessionStorage.setItem(lessonId, title);

						//remove after setting
						UserStorageUtil.deleteSessionItem(lessonId);
					}							
				}

			}


			if(title)
				document.title += title;	
		}catch(e){}
	}	
	
	getAdditionalUrlParams(lessonUrl){
		try{
			var paramsArr = window.location.href.split("?");
			if(paramsArr.length > 1 && paramsArr[1].length > 0){
				lessonUrl += "&"+paramsArr[1];

				var paramObj = this.extractParamsObj(paramsArr[1]);

				this.setLessonNameAsTitle(paramObj["url"]);
			   
			   }
			}catch(e){}

			return lessonUrl;
		}
		getAllParamsObj(){
			var paramObj = {};
			try{
				var paramsArr = window.location.href.split("?");
				if(paramsArr.length > 1 && paramsArr[1].length > 0){
					paramObj = this.extractParamsObj(paramsArr[1]);			   
				}
			}catch(e){}

			return paramObj;
		}
		getAllUrlParams(urlString){
			try{
				var paramsArr = window.location.href.split("?");
				if(paramsArr.length > 1 && paramsArr[1].length > 0){
					if(urlString.indexOf("?") > 0){
						urlString += "&"+paramsArr[1];
					}else{
						urlString += "?"+paramsArr[1];
					}
				}
			}catch(e){}

			return urlString;
		}

		extractParamsObj(paramsArrStr){
			var paramObj = {};
			try{
				if(paramsArrStr !== null && paramsArrStr.length > 0){
					var paramPairArr = paramsArrStr.split("&");
					if(paramPairArr !== null && paramPairArr.length > 0){
						for(var i=0; i < paramPairArr.length; i++){
							var eachPair = paramPairArr[i].split("=");
							paramObj[eachPair[0]] = (eachPair.length > 0) ? eachPair[1] : eachPair[0];
						}
					}
				}
			}catch(e){}

			return paramObj;
		}

		getLessonUrl(){
			
			try{
				var me = this;

				var successHandler = function (data) {
					
					if ((data === null) || (data !== null && data.errorMsg)) {
						var buttons = [{
							label: me.rb("home.btn.close"),
							handler: () => { window.close(); }
						}]
						
						if(data.errorMsg && data.errorMsg === "mobile_no_flash"){
							me.errorMsg={
								heading:me.rb("lesson."+data.errorMsg+".heading") || me.rb("lesson."+data.errorMsg+".heading"),
								srcval:"desktoporlaptop",
								description:me.rb("lesson."+data.errorMsg) || me.rb("lesson."+data.errorMsg)
							}
							me.setState({AlertModalShow:true});
						}
						
						else if(data.errorMsg && data.errorMsg === "not_authorized"){
							me.showAlert(null, me.rb("lesson."+data.errorMsg) || me.rb("lesson."+data.errorMsg), buttons);
						}
						
						else if(data.errorMsg && data.errorMsg === "user_session_not_available"){
							me.showAlert(null, me.rb("lesson."+data.errorMsg) || me.rb("lesson."+data.errorMsg), buttons);
						}
						
						else if(data.errorMsg && data.errorMsg === "no_lesson_id"){
							me.showAlert(null, "<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>", buttons);
						}
						
						else if(data.errorMsg && data.errorMsg === "not_free_lesson"){
							me.showAlert(null, "<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>",'',"no");
						}
						else{
							me.showAlert(null, me.rb(data.errorMsg) || me.rb(data.errorMsg), buttons);
						}
						
						return;
					}
					
					if(data && data.lessonUrl){
						me.setState({ "dataLoaded": true, "data": data, lessonUrl:me.getAdditionalUrlParams(data.lessonUrl), "iFrameHeight":  (window.innerHeight)});
						
						me.trackLessonOpen();
						me.initiateTimer();
						setTimeout(function()
			        	{		        		
			        		me.setContentSize();
			        	},1500);
					}else{
						//Please close this window and login to continue
					}
				}

				var failureHandler = function (err) {
					var buttons = [{
							label: me.rb("home.btn.close"),
							handler: () => { window.close(); }
						}]
					me.showAlert(me.rb("error"), me.rb("generic_connect_error"), buttons);

					return;
				}
				var lessonId = this.props.match.params.id;

				new CoreAjax(this.getAllUrlParams(this.getUrlFor("LESSON_URL_OPEN")+lessonId)).get(successHandler,failureHandler);
			}catch(e){
				var buttons = [{
					label: me.rb("home.btn.close"),
					handler: () => { window.close(); }
				}]
				me.showAlert(me.rb("error"), me.rb("system_error"), buttons);
			}

		}
		trackLessonClose(){
			try{
				var me = this;

				var successHandler = function (data) {
					console.log("track lesson close success");
				}

				var failureHandler = function (err) {
					console.log("Error in TRACK_LESSON_CLOSE");
					return;
				}
				new CoreAjax(this.getUrlFor("TRACK_LESSON_CLOSE")+me.trackId+"/"+me.userId).get(successHandler,failureHandler);
			}catch(e){
				console.log("Error in track lessson close..");
			}
		}
		
		trackLessonOpen(){
			var params = this.getAllParamsObj();
		/*lessonPref:"html5"
		lessonname:"Subtracting%207-Digit%20Numbers"
		revisiontopicid:"0"
		src:"plp"
		testid:"0"
		url:"vl1283a_subtract7digit"*/		
		var formData = {
			"lessonUrl" : params.url, 
			"lessonDd" : (params.lessonPref == "flash") ? 0 : (parseInt(params.dd) || 1), 
			"lessonType" : params.lessonPref, 
			"classId" : parseInt(params.classId), 
			"accessId" : parseInt(params.accessId), 
			"topicSubtopicMapId" : parseInt(params.revisiontopicid)
		}
		
		try{
			var me = this;
			var successHandler = function (data) {
				if (data != null) {
					me.trackId = data.trackId;
					return;
				}

			}

			var failureHandler = function (err) {
				console.log("Error in TRACK_LESSON_OPEN");
				return;
			}
			var lessonId = this.props.match.params.id;

			new CoreAjax(this.getUrlFor("TRACK_LESSON_OPEN"),formData).post(successHandler,failureHandler);
		}catch(e){
			console.log("Error in lesson tracking...");
		}
		
		
	}
	setContentSize()
	{
		var me = this;
		//
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      		//
      		$("#contentIFrame").css("visibility","hidden");
        	setTimeout(function()
        	{
        		$("#contentIFrame").css("visibility","visible");
        		me.resizeCall();
        	},1500);
        	//
    	}
		me.resizeCall();
	}
	//
	resizeCall()
	{
		
		//
		try
		{
			$("#contentIFrame").css({
				width:window.innerWidth,
				height:window.innerHeight
			});
		}catch(e)
		{
		}
	}

	hideAlertModal(){
		this.setState({AlertModalShow:false});
		window.close();
	}
	
	renderModalContent(){
		return(
			<div>							
					<TestTakingModalComponent visible={this.state.AlertModalShow} dialogClassName={"loginModal modal-lg"}>						
					<div className="modal-header bg-purple">
					<div className="modal-title">
					
					</div>
					<div className="close helpClose"  onClick={this.hideAlertModal} aria-label="Close">
					          <span aria-hidden="true"><i className="material-icons">close</i></span>
					        </div>
					</div>
						<div className="modal-body" className="col-12 text-center bdycont">
							<Errmsg errormsg={this.errorMsg}></Errmsg>
						</div>						
					</TestTakingModalComponent>
				</div>
		);
	}

	render() {	
		if(!this.state.dataLoaded || this.state.lessonUrl === null){
			return (<div> 
			{this.showLoader()}
			
			{this.renderModalContent()}
			</div>);
		}else{
			var me = this;
			return (  
			<div id="lessonIframeContainer" style={{height:"100vh", overflowY:'hidden'}}>
				<iframe 
				id="contentIFrame"
				style={{width:'100%', height:me.state.iFrameHeight, overflowY:'hidden'}}
				onLoad={() => {
					me.setContentSize();
					me.setState({
						"iFrameHeight":  (window.innerHeight) + 'px'
					});
				}} 
				ref="iframe" 
				src={this.state.lessonUrl}
				width="100%" 
				height={me.state.iFrameHeight} 
				scrolling="no" 
				frameBorder="0"	
				referrerpolicy="no-referrer-when-downgrade"
				/>

				{this.renderModalContent()}
			</div>
			);
		}
	}

}


// WEBPACK FOOTER //
// ./src/views/lesson/OpenLessonView.js